<template>
  <Modal
    :value="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="680"
    class-name="invoice-reject-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">驳回开票详情</span>
    </div>

    <div class="modal-body">
      <!-- 申请信息 -->
      <div class="section">
        <div class="section-title">申请信息</div>
        <div class="info-list">
          <div class="info-row">
            <span class="info-label">订单编号：</span>
            <span class="info-value">{{ data.order_no || '-' }}</span>
          </div>
          <div class="info-row product-row">
            <span class="info-label">订单商品：</span>
            <div class="product-box" v-if="firstProduct">
              <img v-if="firstProduct.product_image" :src="firstProduct.product_image" class="product-img" alt="" />
              <div class="product-info">
                <div class="product-name">{{ firstProduct.product_name || '-' }}</div>
                <div class="product-spec">{{ firstProduct.product_spec || '-' }} ×{{ firstProduct.product_qty || 1 }}</div>
              </div>
            </div>
            <span v-else class="info-value">-</span>
          </div>
          <div class="info-row">
            <span class="info-label">买家信息：</span>
            <span class="info-value">{{ data.nickname || '-' }} {{ data.mobile || '' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票抬头：</span>
            <span class="info-value">{{ data.title || '-' }}</span>
            <span class="copy-link" @click="onCopy(data.title)">复制</span>
          </div>
          <div class="info-row">
            <span class="info-label">抬头类型：</span>
            <span class="info-value">{{ typeText(data.type) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票类型：</span>
            <span class="info-value">{{ taxTypeText(data.tax_type) }}</span>
          </div>
          <template v-if="data.type === 2">
            <div class="info-row">
              <span class="info-label">税号：</span>
              <span class="info-value">{{ data.tax_number || '-' }}</span>
            </div>
            <div v-if="data.bank_name" class="info-row">
              <span class="info-label">开户银行：</span>
              <span class="info-value">{{ data.bank_name || '-' }}</span>
            </div>
            <div v-if="data.bank_account" class="info-row">
              <span class="info-label">银行账号：</span>
              <span class="info-value">{{ data.bank_account || '-' }}</span>
            </div>
            <div v-if="data.company_address" class="info-row">
              <span class="info-label">企业地址：</span>
              <span class="info-value">{{ data.company_address || '-' }}</span>
            </div>
            <div v-if="data.phone" class="info-row">
              <span class="info-label">企业电话：</span>
              <span class="info-value">{{ data.phone || '-' }}</span>
            </div>
          </template>
          <div class="info-row">
            <span class="info-label">开票金额：</span>
            <span class="info-value">¥{{ data.pay_amount || '0.00' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">买家邮箱：</span>
            <span class="info-value">{{ data.send_mail || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">申请时间：</span>
            <span class="info-value">{{ data.create_time || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 驳回原因 -->
      <div class="section">
        <div class="form-row">
          <span class="form-label required">驳回原因</span>
          <Select v-model="rejectForm.reason" placeholder="请选择驳回原因" style="width: 100%">
            <Option value="信息不全">发票信息不全</Option>
            <Option value="信息有误">发票信息有误</Option>
            <Option value="无法开票">超出开票范围，无法开票</Option>
            <Option value="其他">其他原因</Option>
          </Select>
        </div>
        <div class="form-row">
          <span class="form-label">驳回备注</span>
          <Input
            v-model="rejectForm.remark"
            type="textarea"
            :rows="4"
            placeholder="请详细填写驳回原因，方便买家理解"
          />
        </div>
        <div class="form-tip">请填写驳回原因并填写备注，确认驳回后买家将收到驳回通知</div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="modal-footer">
      <div class="btn cancel" @click="onCancel">取消</div>
      <div class="btn confirm" :class="{ disabled: !rejectForm.reason }" @click="onConfirm">
        确认驳回
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'InvoiceRejectModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rejectForm: {
        reason: '',
        remark: '',
      },
    }
  },
  computed: {
    firstProduct() {
      return (this.data && this.data.products && this.data.products[0]) || null
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.rejectForm = {
          reason: '',
          remark: '',
        }
      }
    },
  },
  methods: {
    typeText(type) {
      return type == 2 ? '企业' : '个人'
    },
    taxTypeText(taxType) {
      return taxType == 1 ? '电子专用发票' : '电子普通发票'
    },
    onVisibleChange(val) {
      this.$emit('update:visible', val)
    },
    onCopy(text) {
      if (!text) return
      navigator.clipboard.writeText(text).then(() => {
        this.$layer.msg("复制成功");
      });
    },
    onCancel() {
      this.$emit('cancel')
      this.$emit('update:visible', false)
    },
    onConfirm() {
      if (!this.rejectForm.reason) {
        this.$Message.warning('请选择驳回原因')
        return
      }
      this.$emit('confirm', {
        id: this.data.id,
        reject_reason: this.rejectForm.reason,
        reject_remark: this.rejectForm.remark,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .invoice-reject-modal {
  text-align: left;
  .ivu-modal-content {
    border-radius: 10px;
  }

  .ivu-modal-body {
    padding: 0;
  }

  .ivu-modal-close {
    top: 16px;
    right: 16px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 24px 13px 24px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;

  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #0F1115;
  }
}

.modal-body {
  padding: 16px 24px;
  max-height: 70vh;
  overflow-y: auto;

  .section {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      font-size: 14px;
      font-weight: bold;
      color: #1a1a1a;
      margin-bottom: 16px;
      padding-left: 8px;
      border-left: 3px solid #ff5967;
    }

    .info-list {
      .info-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        font-size: 14px;

        .info-label {
          color: #999999;
          width: 80px;
          flex-shrink: 0;
        }

        .info-value {
          color: #333333;
          flex: 1;
        }

        .copy-link {
          color: #0d99ff;
          cursor: pointer;
          font-size: 12px;
          margin-left: 8px;

          &:hover {
            opacity: 0.8;
          }
        }

        &.product-row {
          .product-box {
            display: flex;
            gap: 10px;

            .product-img {
              width: 60px;
              height: 60px;
              object-fit: cover;
              border-radius: 4px;
              border: 1px solid #f0f0f0;
            }

            .product-info {
              .product-name {
                font-size: 14px;
                color: #333333;
                line-height: 1.4;
              }

              .product-spec {
                font-size: 12px;
                color: #999999;
                margin-top: 4px;
              }
            }
          }
        }
      }
    }

    .form-row {
      margin-bottom: 16px;

      .form-label {
        display: block;
        font-size: 14px;
        color: #333333;
        margin-bottom: 8px;

        &.required::after {
          content: '*';
          color: #ff5967;
          margin-left: 4px;
        }
      }
    }

    .form-tip {
      font-size: 12px;
      color: #999999;
      margin-top: 8px;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 18px 24px 22px 24px;
  border-top: 1px solid #e0e0e0;

  .btn {
    min-width: 120px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 20px;

    &.cancel {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      color: #999999;
    }

    &.confirm {
      background: #ff5967;
      color: #ffffff;

      &:hover {
        opacity: 0.9;
      }

      &.disabled {
        background: #f5f5f5;
        color: #999999;
        cursor: not-allowed;
        border: 1px solid #e3e3e3;
      }
    }
  }
}
</style>
